var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-sliced-text u-relative u-force-inline u-force-3d u-fit-w"},[_c('div',{staticClass:"c-sliced-text__base",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }